import { Navigate } from "react-router-dom";
import {useSelector} from 'react-redux';
import { Outlet } from 'react-router';

export default function LoggedIn() {
  let loggedIn= useSelector(state => state.auth.token);
    return (
      <>
      {!loggedIn && <Navigate to="/login" />}
      <Outlet />
      </>
    )
}


